export default {
  FETCH_CTAS_REQUEST: 'FETCH_CTAS_REQUEST',
  FETCH_CTAS_FAILED: 'FETCH_CTAS_FAILED',
  FETCH_CTAS_SUCCESS: 'FETCH_CTAS_SUCCESS',

  ADD_CTA_REQUEST: 'ADD_CTA_REQUEST',
  ADD_CTA_FAILED: 'ADD_CTA_FAILED',
  ADD_CTA_SUCCESS: 'ADD_CTA_SUCCESS',

  UPDATE_CTA_REQUEST: 'UPDATE_CTA_REQUEST',
  UPDATE_CTA_FAILED: 'UPDATE_CTA_FAILED',
  UPDATE_CTA_SUCCESS: 'UPDATE_CTA_SUCCESS',

  DELETE_CTA_REQUEST: 'DELETE_CTA_REQUEST',
  DELETE_CTA_FAILED: 'DELETE_CTA_FAILED',
  DELETE_CTA_SUCCESS: 'DELETE_CTA_SUCCESS'
};
